import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Radio } from "lucide-react";
import Countdown from "@/components/Countdown";

export default function LiveStatusBar() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    api.get("/stats").then(({ data }) => setStats(data)).catch(() => {});
  }, []);
  if (!stats) return null;

  const Item = ({ label, value, testid }) => (
    <div className="flex flex-col items-center px-3 sm:px-5" data-testid={testid}>
      <span className="font-mono text-sm sm:text-base text-amber-200 tabular-nums">{value}</span>
      <span className="text-[0.55rem] uppercase tracking-[0.2em] text-amber-500/70">{label}</span>
    </div>
  );

  return (
    <div className="border-y border-gold/20 bg-amber-950/25" data-testid="live-status-bar">
      <div className="section flex items-center gap-1 overflow-x-auto py-2.5 no-scrollbar">
        <span className="flex items-center gap-1.5 whitespace-nowrap pr-3 text-[0.6rem] font-mono uppercase tracking-widest text-red-400">
          <Radio className="h-3 w-3 animate-pulse" /> {stats.phase}
        </span>
        <Item testid="stat-candidates" label="Candidates" value={stats.total_candidates} />
        <Item testid="stat-delegations" label="Delegations" value={stats.total_delegations} />
        <Item testid="stat-votes" label="Verified Votes" value={Number(stats.total_votes).toLocaleString()} />
        {stats.finale_date && (
          <div className="ml-auto hidden sm:block pl-3">
            <Countdown target={stats.finale_date} compact />
          </div>
        )}
      </div>
    </div>
  );
}
